module.exports = __webpack_public_path__ + "static/img/lack_of_elasticity-01.472bfd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/lack_of_elasticity-01.jpg
// module id = 272
// module chunks = 1